import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Material & Layout
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// Your Components
import { CategoryDistributionComponent } from '../category-distribution/category-distribution.component';
import { OutcomeDistributionComponent } from '../outcome-distribution/outcome-distribution.component';
import { OutcomeRateComponent } from '../outcome-rate/outcome-rate.component';
import { EngagementFrequencyComponent } from '../engagement-frequency/engagement-frequency.component';
import { CrossTabComponent } from '../cross-tab/cross-tab.component';
import { ConversationExplorerComponent } from '../conversation-explorer/conversation-explorer.component';
import { AuthService } from '../../../services/auth';
import { DataTableComponent } from '../data-table/data-table.component';

@Component({
  selector: 'app-insights',
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatTabsModule, MatButtonModule, 
    MatIconModule, MatDatepickerModule, MatFormFieldModule, MatInputModule,
    CategoryDistributionComponent, OutcomeDistributionComponent,
    OutcomeRateComponent, EngagementFrequencyComponent, 
    CrossTabComponent, ConversationExplorerComponent, DataTableComponent
  ],
  templateUrl: './insights.component.html',
  styleUrls: ['../category-distribution/category-distribution.component.scss','insights.component.scss'] // Reusing your existing styles
})
export class InsightsComponent {
  startDate = new Date();
  endDate = new Date();
  user
  allowInsight;

  constructor(private authService:AuthService) {
    // Default range: Last 30 days
    this.startDate.setDate(this.endDate.getDate() - 30);

    
  }

  // This function can be used to trigger 'loadData' in all children 
  // if you pass the dates as @Input() to the child components.
  refreshAll() {
    console.log('Refreshing all insights for range:', this.startDate, this.endDate);
  }
  ngOnInit(){
      this.authService.user$.subscribe(user=>{
      if(user){
        this.user = user;
        this.checkClaims()
      }
    })
  }

  async checkClaims(){
    const tokenResult = await this.user.getIdTokenResult();
    this.allowInsight = tokenResult.claims.view_insights === true||tokenResult.claims.admin === true;
    // console.log('Insights:',this.allowInsight,tokenResult.claims)
  }
}